module.exports = __webpack_public_path__ + "img/Rakuten.f0a984b5.jpg";